import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import arTranslations from '../locales/ar.json';
import enTranslations from '../locales/en.json';
import yoTranslations from '../locales/yo.json';
import haTranslations from '../locales/ha.json';
import hiTranslations from '../locales/hi.json';
import esTranslations from '../locales/es.json';
import bnTranslations from '../locales/bn.json';
import { DEFAULT_LANGUAGE } from '../utils/constants';

const resources = {
  ar: { translation: arTranslations },
  en: { translation: enTranslations },
  yo: { translation: yoTranslations },
  ha: { translation: haTranslations },
  hi: { translation: hiTranslations },
  es: { translation: esTranslations },
  bn: { translation: bnTranslations },
};

void i18n
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'en',
    lng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      // Order of language detection
      order: [
        'localStorage',
        'navigator',
        'htmlTag',
        'path',
        'subdomain',
      ],
      // Keys to store language preference
      caches: ['localStorage'],
      // HTML lang attribute
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;

